import {
  BrowserRouter as Router,
  Routes,
  Route,
  useParams,
  useNavigate,
  useLocation
} from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import CareerCard from "./components/Carrera";
import SeccionMas from "./components/SeccionMas";
import SeleccionarSede from "./pages/SeleccionarSede";
import Interaccion from "./components/inteaccion";
import ScrollToTop from "./components/ScrollToTop";
import investigacion from "./components/investigacion";
import RedAlumni from "./components/RedAlumni";
import ServiciosVirtuales from "./components/ServiciosVirtuales";
import Loader from "./components/Loader";

import { useState, useEffect } from "react";

// 🔹 Normaliza params
function RouteWrapper({ element: Element }) {
  const navigate = useNavigate();
  const params = useParams();

  useEffect(() => {
    let normalized = false;
    const newParams = {};

    Object.keys(params).forEach((key) => {
      if (params[key] && params[key] !== params[key].toLowerCase()) {
        newParams[key] = params[key].toLowerCase();
        normalized = true;
      }
    });

    if (normalized) {
      let path = window.location.pathname.replace(/^\/web/, "");

      Object.keys(newParams).forEach((key) => {
        const re = new RegExp(params[key], "i");
        path = path.replace(re, newParams[key]);
      });

      navigate(path, { replace: true });
    }
  }, [params, navigate]);

  return <Element />;
}

// 🔥 DETECTA CAMBIO DE SEDE
function AppInner({ startLoading }) {
  const location = useLocation();
  const [prevSede, setPrevSede] = useState("");

  useEffect(() => {
    const pathParts = location.pathname.split("/");
    const currentSede = pathParts[1] || "";

    // ❌ no ejecutar en inicio
    if (location.pathname === "/") {
      setPrevSede(currentSede);
      return;
    }

    // 🔥 cambio de sede interno
    if (prevSede && currentSede && prevSede !== currentSede) {
      startLoading();
    }

    setPrevSede(currentSede);
  }, [location.pathname]);

  return (
    <>
      <ScrollToTop />

      <Routes>
        <Route
          path="/"
          element={<SeleccionarSede startLoading={startLoading} />}
        />

        <Route
          path="/:sede"
          element={
            <>
              <RouteWrapper element={Header} />
              <main className="bg-white min-h-screen">
                <RouteWrapper element={Home} />
              </main>
              <Footer />
            </>
          }
        />

        <Route
          path="/:sede/carrera/:carrera"
          element={
            <>
              <RouteWrapper element={Header} />
              <main className="bg-white min-h-screen">
                <RouteWrapper element={CareerCard} />
              </main>
              <Footer />
            </>
          }
        />

        <Route
          path="/:sede/redalumni/:seccion"
          element={
            <>
              <RouteWrapper element={Header} />
              <main className="bg-white min-h-screen">
                <RouteWrapper element={RedAlumni} />
              </main>
              <Footer />
            </>
          }
        />

        <Route
          path="/:sede/mas/:seccion"
          element={
            <>
              <RouteWrapper element={Header} />
              <main className="bg-white min-h-screen">
                <RouteWrapper element={SeccionMas} />
              </main>
              <Footer />
            </>
          }
        />

        <Route
          path="/:sede/interaccion/:programa"
          element={
            <>
              <RouteWrapper element={Header} />
              <main className="bg-white min-h-screen">
                <RouteWrapper element={Interaccion} />
              </main>
              <Footer />
            </>
          }
        />

        <Route
          path="/:sede/:tipo"
          element={
            <>
              <RouteWrapper element={Header} />
              <main className="bg-white min-h-screen">
                <RouteWrapper element={ServiciosVirtuales} />
              </main>
              <Footer />
            </>
          }
        />

        <Route
          path="/:sede/investigacion/:seccion"
          element={
            <>
              <RouteWrapper element={Header} />
              <main className="bg-white min-h-screen">
                <RouteWrapper element={investigacion} />
              </main>
              <Footer />
            </>
          }
        />

        <Route
          path="*"
          element={
            <div className="text-center mt-5" style={{ fontSize: "1.5rem" }}>
              Página no encontrada
            </div>
          }
        />
      </Routes>
    </>
  );
}

// 🚀 APP PRINCIPAL
export default function App() {
  const [loading, setLoading] = useState(false);

  const startLoading = () => {
    setLoading(true);
  };

  const finishLoading = () => {
    setLoading(false);
  };

  return (
    <>
      <Router basename="/web">
        <AppInner startLoading={startLoading} />
      </Router>

      {/* 🔥 Loader encima de todo */}
      {loading && <Loader onFinish={finishLoading} />}
    </>
  );
}